import { IEventCard } from 'constants/types/card.types'

const setElementArrActive = (
  arr: IEventCard[],
  id: number,
  key = 'isActive',
  value = true
): IEventCard[] => {
  const finalArr = arr.map((item) => {
    if (item.id !== id) return item
    return { ...item, [key]: value }
  })
  return finalArr
}

const formattedNextWebinars = (webinars: any[]): any[] =>
  webinars.map((item) => ({ ...item, isActive: false }))

const formatWebinarIsSubscribed = (webinars: any[]): any[] =>
  webinars.map((item) => ({ ...item, isSubscribed: true }))

const sortByDate = (a: IEventCard, b: IEventCard) =>
  (a.startDate as number) - (b.startDate as number)

export { setElementArrActive, formattedNextWebinars, formatWebinarIsSubscribed, sortByDate }
